import React, { useCallback, useEffect, useState } from 'react';
import { DownOutlined, PlusOutlined} from '@ant-design/icons';
import { Button, Dropdown, Menu, Table, Modal, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import {
    SoilProfileAsia,
    SoilProfileAfrica,
    SoilProfileAntartica,
    SoilProfileEurope,
    SoilProfileNorthAmeraica,
    SoilProfileOceania,
    SoilProfileSourthAmeraica,
    SoilProfileFolderIcon,
    SoilProfileHomeIcon,
    ExclamationMarkSvgComponent,
    SoilProfileWarningAlertIcon,
    SoilCloseIcon,
} from '@/resource/IconComponentSets';
import TableHeaderCell from '@/components/TableHeaderCell';
import TableHeaderLocationCell from './Component/TableHeaderLocationCell';
import IF from '@/components/IF';
import ProfileCountImg from '@/resource/icon-png/all-profile-count.png';

import {
    fetchSoilProfileList,
    soilProfileDeleteTargetProfile,
    soilProfileGetAllProfilesCount,
    soilProfileGetCountries,
    soilProfileGetFieldType,
    soilProfileGetLayersDetail,
    soilProfileGetMyProfilesCount,
    soilProfileGetMySoilProfileList,
    soilProfileGetRegion,
    soilProfileGetSoilProfileDetail,
    soilProfileGetValiadateStatus
} from '@/util/Request';
import { RootState } from '@/redux';
import {
    loadingCountryFromServer,
    loadMore,
    refresh,
    updateProfilesCount,
    updateValidateStatus,
    loadMoreBaseOnRegion,
    refreshCurrentProfileList,
    loadRegionFromServer,
} from '@/redux/reducer/soilProfile';
import SoilProfilePreview from './Component/SoilProfilePreview';
import SoilProfileCreateView from './Component/SoilProfileCreateView';
import { ISoilProfileGetCountriesResModel, ISoilProfileGetLayersDetailResModel, ISoilProfileGetSoilDetailResModel, ISoilProfileModel, ISoilProfilesRequestModel } from '@/util/Request/requestType';
import { updatePanelVisible, updateProfileSelectedList, updateShowLoading } from '@/redux/reducer/common';
import { resetTheSoilCreatProfiles, updateFieldTypes, updateSelectedSoilAnalysisVisible } from '@/redux/reducer/SoilCreatProfiles';
import HeaderSearch from '@/components/HeaderSearch';
import DetailModel from '@/page/Soil/soil-analyses/Component/DetailModel/DetailModel';
import AddModel from '@/page/Soil/soil-analyses/Component/AddModel/AddModel';
const { confirm } = Modal;


enum RegionMap {
    northUSA = 'NA',
    europe = 'EU',
    asia = 'AS',
    antarctica = 'AN',
    sourthUSA = 'SA',
    africa = 'AF',
    oceania = 'OC'
}

interface ISoilProfileRequestCacheParam {
    localSortRegion: boolean
    searchString: string
    cacheAscending: boolean
    sortCol: 'code' | 'name',
    strType: string,
    strStatus: string
    selectedStateCount: number
}

export default function soilProfile() {
    const [visible, setVisible] = useState(false);
    const [showStateSelector, setShowStateSelector] = useState(true);
    const [selectedRegion, setSelectedRegion] = useState({
        northUSA: false,
        europe: false,
        asia: false,
        antarctica: false,
        sourthUSA: false,
        africa: false,
        oceania: false
    });
    // dynamic show the count of the selected state
    const [selectedStateCount, setSelectedStateCount] = useState(0);
    const [selectMySoilProfile, setSelectMySoilProfile] = useState(false);
    const [profileDetailVisible, setProfileDetailVisible] = useState(false);
    // set the selected countries concat string
    const [selectedCountriesString, setSelectedCountriesString] = useState('');
    // click the target profile row and show the profile detail
    const [layerDetail, setLayerDetail] = useState<ISoilProfileGetLayersDetailResModel[]>();
    const [profileDetail, setProfielDetail] = useState<ISoilProfileGetSoilDetailResModel>();
    // if false equal to select all  true equal to region
    const [sortByRegion, setSortByRegion] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    // automatic to get filter menu data
    const [statusDataSource, setStatusDataSource] = useState<Set<string>>(new Set());
    const [fielTypeDataSource, setFielTypeDataSource] = useState<Set<string>>(new Set());
    // set the sort rule
    const [ascending, setAscending] = useState(false);
    const [sortCol, setSortCol] = useState<'code' | 'name'>('code');
    const [searchString, setSearchString] = useState('');
    const [stateSelectSpining, setStateSelectSpining] = useState(false);
    const [profileDatailSpin, setProfileDatailSpin] = useState(false);
    const [allProfileCountModalVisible, setAllProfileCountModalVisible] = useState(false);
    const [currentFilterType, setCurrentFilterType] = useState('');
    const [currentFilterStatus, setCurrentFilterStatus] = useState('');
    const [allProfilesCount, setAllProfilesCount]= useState('0');
    const [editParam, setEditParam] = useState<string>();
    const [addAnalysisVisible, setAddAnalysisVisible] = useState(false);

    //SECTION: store value area---------------------------------------------------------
    const dispatch = useDispatch();

    const soilProfilesList = useSelector((state: RootState) => state.soilPageData.soilProfilesList);
    const originalProfileList = useSelector((state: RootState) => state.soilPageData.originalProfileList);
    const isAuthenticate = useSelector((state: RootState) => state.soilUser.isAuthenticate);
    const regionIds = useSelector((state: RootState) => state.soilPageData.regionIds);
    const countries = useSelector((state: RootState) => state.soilPageData.countries);
    const pageIndex = useSelector((state: RootState) => state.soilPageData.pageIndex);
    const pageSize = useSelector((state: RootState) => state.soilPageData.pageSize);
    const profilesCount = useSelector((state: RootState) => state.soilPageData.profilesCount);
    const profileSelectedList = useSelector((state: RootState) => state.commonData.profileSelectedList);
    const validateStatus = useSelector((state: RootState) => state.soilPageData.validateStatus);
    const fieldTypes = useSelector((state: RootState) => state.soilprofileCreateData.fieldTypes);
    const selectedSoilAnalysis = useSelector((state: RootState) => state.soilprofileCreateData.selectedSoilAnalysis);
    const selectedSoilAnalysisVisible = useSelector((state: RootState) => state.soilprofileCreateData.selectedSoilAnalysisVisible);
    const userInfo = useSelector((state: RootState) => state.soilUser.userInfo);

    // SECTION: useCallback area---------------------------------------------------------
    // fetch profile table list data
    const refreshProfileList = useCallback(async (props: ISoilProfileRequestCacheParam) => {
        try {
            const {
                localSortRegion,
                searchString,
                cacheAscending,
                sortCol,
                strType,
                strStatus,
                selectedStateCount
            } = props;

            if (selectedStateCount === 0) {
                dispatch(refresh({
                    soilProfilesList: [] as ISoilProfileModel[],
                    originalProfileList: [] as ISoilProfileModel[]
                }));
                return;
            }
            if (isAuthenticate) {
                // set the default sort rule
                const requestParam: ISoilProfilesRequestModel = {
                    pageIndex: 1,
                    pageSize: pageSize,
                    countryCode: selectedStateCount < 7 ? selectedCountriesString : '',
                    searchString,
                    sortCol: sortCol,
                    order: cacheAscending ? 'ASC' : 'DESC',
                    strType: strType === 'all' ? '' : strType,
                    strStatus: strStatus === 'all' ? '' : strStatus
                };

                // dispatch(updateShowLoading(true));
                let response;
                if (selectMySoilProfile) {
                    response = await soilProfileGetMySoilProfileList(requestParam);
                } else {
                    response = await fetchSoilProfileList(requestParam);
                }
                let sortRegionArr = [...response];
                if (localSortRegion) {
                    sortRegionArr = sortByRegionFunc(sortRegionArr);
                }
                dispatch(refresh({
                    soilProfilesList: sortRegionArr,
                    originalProfileList: response
                }));
                // dispatch(updateShowLoading(false));
            } else {
                // dispatch(updateShowLoading(false));
            }
            setIsFetching(false);
        } catch(err) {
            console.log('fetch profiles error', err);
            setIsFetching(false);
        }
    }, [
        isAuthenticate,
        selectedCountriesString,
        ascending,
        sortCol,
        selectMySoilProfile,
        sortByRegion,
        selectedStateCount
    ]);

    // load more ase on the countries selected to request profile list data
    const fetchProfilesByCountries = useCallback(async () => {
        try {
            // if selected no countries should be fetch profiles by default way
            const requestParam: {
                countryCode?: string,
                pageIndex: number,
                pageSize: number,
                searchString?: string,
                sortCol: 'code' | 'name',
                order: 'ASC' | 'DESC',
                strType: string,
                strStatus: string
            } = {
                pageIndex,
                pageSize,
                searchString,
                sortCol,
                order: ascending ? 'ASC' : 'DESC',
                countryCode: selectedStateCount < 7 ? selectedCountriesString : '',
                strType: currentFilterType === 'all' ? '' : currentFilterType,
                strStatus: currentFilterStatus === 'all' ? '' : currentFilterStatus
            };
            let response;
            if (selectMySoilProfile) {
                response = await soilProfileGetMySoilProfileList(requestParam);
            } else {
                response = await fetchSoilProfileList(requestParam);
            }

            // if current model is under sortby region
            if (response.length === 0) throw new Error('request finish');
            // if under sort by region model
            if (sortByRegion) {
                const newlySoilProfileList = [...originalProfileList, ...response];
                const sortRegionProfiles = sortByRegionFunc(newlySoilProfileList);
                return dispatch(loadMoreBaseOnRegion({
                    soilProfilesList: sortRegionProfiles,
                    originalProfileList: response
                }));
            }
            // normal model
            dispatch(loadMore({
                soilProfilesList: response,
                originalProfileList: response
            }));
            setIsFetching(false);
            // dispatch(updateShowLoading(false));
        } catch (err) {
            setIsFetching(false);
            // dispatch(updateShowLoading(false));
            console.log('err', err);
        }
    }, [
        pageIndex,
        originalProfileList,
        sortByRegion,
        sortCol,
        ascending,
        selectedCountriesString,
        selectedStateCount,
        currentFilterType,
        currentFilterStatus
    ]);

    // fetch all countries array if user do any action on the state selected modal
    const fetchAllConutries = useCallback(async () => {
        try {
            setStateSelectSpining(true);
            const regionRes = await soilProfileGetRegion();
            dispatch(loadRegionFromServer(regionRes));
            let regionIds = '';
            regionRes.forEach(item => {
                regionIds += `${item.regionId},`;
            });

            const allCountries = await soilProfileGetCountries(regionIds);

            const countries: { string?: ISoilProfileGetCountriesResModel[] } = {};
            allCountries.forEach((country) => {
                if (!countries[country.regionId]) {
                    countries[country.regionId] = [country];
                } else {
                    countries[country.regionId].push(country);
                }
            });
            dispatch(loadingCountryFromServer(countries));
            setStateSelectSpining(false);
        } catch (err) {
            setStateSelectSpining(false);
            console.log('request err', err);
        }
    }, [selectedRegion]);

    const fetchMySoilProfilesCount = useCallback(async () => {
        try {
            const profilesCount = await soilProfileGetMyProfilesCount();
            dispatch(updateProfilesCount(parseInt(profilesCount)));
        } catch(err) {
            console.log('err', err);
        }
    }, []);

    const fetchAllSoilProfilesCount = useCallback(async () => {
        try {
            const allProfilesCount = await soilProfileGetAllProfilesCount();
            setAllProfilesCount(allProfilesCount);
        } catch(err) {
            console.log(err);
        }
    }, []);

    // FIXME: test
    const fetchSelectedStateProfiles = useCallback(async () => {
        // change the count of the region selected count
        const keysArray = Object.keys(selectedRegion);
        let selectedCount = 0;
        let selectCountries = [];
        keysArray.forEach((key) => {
            const isSelected = selectedRegion[key];
            if (isSelected) {
                selectedCount += 1;
                // push all region's countries request in array
                if (countries && Object.keys(countries).length > 0) {
                    selectCountries = [...selectCountries, ...countries[RegionMap[key]]];
                }
            }
        });

        setSelectedStateCount(selectedCount);

        // base on the selected of the region to request for soil profiles list
        let getProfilesByStateRequestParams = '';
        selectCountries.forEach((country: ISoilProfileGetCountriesResModel) => {
            getProfilesByStateRequestParams += country.countryCode2 + ',';
        });
        setSelectedCountriesString(getProfilesByStateRequestParams);

    }, [selectedRegion, isAuthenticate, countries]);

    // handle fieldType filter
    const handleFilterTargetType = (targetType: string) => {
        setCurrentFilterType(targetType);
        setSortByRegion(false);
        refreshProfileList({
            localSortRegion: false,
            searchString: searchString,
            cacheAscending: ascending,
            sortCol: sortCol,
            strType: targetType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    };

    // handle status field fielter
    const handleFilterTargetStatus = (targetStatus: string) => {
        setCurrentFilterStatus(targetStatus);
        setSortByRegion(false);

        refreshProfileList({
            localSortRegion: false,
            searchString: searchString,
            cacheAscending: ascending,
            sortCol: sortCol,
            strType: currentFilterType,
            strStatus: targetStatus,
            selectedStateCount
        });
    };

    const fetchFieldTypes = useCallback(async () => {
        try {
            // if fielsTypes is null
            if (!fieldTypes.length) {
                const response = await soilProfileGetFieldType();
                response.reverse();
                dispatch(updateFieldTypes(response));
            }
        } catch (err) {
            console.log('response', err);
        }
    }, []);

    const fetchValidateStatus = useCallback(async () => {
        try {
            const response = await soilProfileGetValiadateStatus();
            dispatch(updateValidateStatus(response));
        } catch (err) {
            console.log('response', err);
        }
    }, []);

    // Country header
    const handlCellColSpan = (record: ISoilProfileModel) => {
        const firstWord = record?.placeName?.split(',')[0];
        if (firstWord === 'Country') {
            return { colSpan: 0 };
        } else {
            return { colSpan: 1 };
        }
    };

    const handlPlaceNameCellColSpan = (record: ISoilProfileModel) => {
        const firstWord = record?.placeName?.split(',')[0];
        if (firstWord === 'Country') {
            return { colSpan: 8 };
        } else {
            return { colSpan: 1 };
        }
    };

    const handleSoilAnalysisDateFormat = (date: string) => {
        const targetDate = date.substring(0, 10);
        const dateArr = targetDate.split('/');
        const resultDateArr = dateArr.reverse().join('-');
        return resultDateArr;
    };

    // get the profile detail if user click any row on table
    const fetchProfilePreviewData = async (profileCode, profileId) => {
        try {
            setProfileDatailSpin(true);
            const profileDetail = await soilProfileGetSoilProfileDetail(profileCode);
            const layerDetail = await soilProfileGetLayersDetail(profileId);
            setLayerDetail(layerDetail);
            setProfielDetail(profileDetail);
            setProfileDatailSpin(false);
        } catch(err) {
            console.log('err', err);
        }
    };

    // SECTION: useEffect area---------------------------------------------------------
    useEffect(() => {
        if (profilesCount === 0 && isAuthenticate) {
            fetchMySoilProfilesCount();
        }
    }, [isAuthenticate]);

    useEffect(() => {
        const statusSet = new Set<string>();
        const typeSet = new Set<string>();
        statusSet.add('all');
        typeSet.add('all');
        if (fieldTypes.length > 0) {
            fieldTypes.forEach(item => {
                typeSet.add(item.fileTypeName);
            });
        }

        if (validateStatus.length > 0) {
            validateStatus.forEach(item => {
                statusSet.add(item.validationStatusName);
            });
        }
        setStatusDataSource(statusSet);
        setFielTypeDataSource(typeSet);
    }, [fieldTypes, validateStatus]);

    useEffect(() => {
        if (!isFetching) return;
        // if country select total count less than 7, pass contry string
        fetchProfilesByCountries();
    }, [isFetching]);

    useEffect(() => {
        // if login success enter the request profiles relate the countries
        fetchSelectedStateProfiles();
    }, [selectedRegion]);

    useEffect(() => {
        const regionKeys = Object.keys(selectedRegion);
        let haveSelected = false;
        for (const regionKey of regionKeys) {
            haveSelected = haveSelected || selectedRegion[regionKey];
        }
        if (!haveSelected) {
            return;
        }
        // if click the My button reset the all config
        setAscending(false);
        setSortCol('code');
        setSortByRegion(false);
        setSearchString('');
        refreshProfileList({
            localSortRegion: false,
            searchString: '',
            cacheAscending: false,
            sortCol: 'code',
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    }, [selectMySoilProfile]);

    useEffect(() => {
        window.addEventListener('scroll', () => handleScroll());
        return () => window.removeEventListener('scroll', () => handleScroll());
    }, []);

    useEffect(() => {
        if (sortByRegion) {
            const sortRegionProfile = sortByRegionFunc(originalProfileList);
            dispatch(refreshCurrentProfileList({soilProfilesList: sortRegionProfile }));
        } else {
            dispatch(refreshCurrentProfileList({soilProfilesList: [...originalProfileList] }));
        }
    }, [sortByRegion]);

    // no need for login we request for fieldtypes and status
    useEffect(() => {
        if (!regionIds && !countries) {
            fetchAllConutries();
        }
        // request for fieldtypes
        if (fieldTypes.length === 0 ) {
            fetchFieldTypes();
        }

        if (validateStatus.length === 0) {
            fetchValidateStatus();
        }
        fetchAllSoilProfilesCount();
    }, []);

    useEffect(() => {
        if ((showStateSelector || profileDetailVisible || visible)) {
            dispatch(updatePanelVisible(false));
        }
    }, [showStateSelector, profileDetailVisible, visible]);

    useEffect(() => {
        const regionKeys = Object.keys(selectedRegion);
        let haveSelected = false;
        for (const regionKey of regionKeys) {
            haveSelected = haveSelected || selectedRegion[regionKey];
        }
        if (!haveSelected) {
            return;
        }
        if (profileSelectedList.length === 0) {
            refreshProfileList({
                localSortRegion: sortByRegion,
                searchString: searchString,
                cacheAscending: ascending,
                sortCol,
                strType: currentFilterType,
                strStatus: currentFilterStatus,
                selectedStateCount
            });
        }
    }, [profileSelectedList]);

    /* ==========================  sorce hard code or ui Area =========================== */
    // define the all button list
    const menusArr = [
        { label: 'All', key: 'all', onClick: () => splitByAllButtonClick() },
        { label: 'Split by country', key: 'split-by-region', onClick: () => splitByRegionButtonClick() }
    ];

    // SECTION:  define columns
    const columns = [
        {
            title: () => (
                <TableHeaderLocationCell
                    showStateCallback={() => setShowStateSelector(true)}
                    selectedStateCount={selectedStateCount}
                    clearTheSelectedStateCallback={() =>
                        setSelectedRegion({
                            northUSA: false,
                            europe: false,
                            asia: false,
                            antarctica: false,
                            sourthUSA: false,
                            africa: false,
                            oceania: false
                        })
                    }
                />
            ),
            width: '200px',
            key: 'record',
            render: (record) => {
                const result = record.placeName.split(',');
                const isCountryNameSection = result[0] === 'Country';
                if (isCountryNameSection) {
                    return <div className='country-name-div'><div className='cover-div-block'/><span>{result[1]}</span></div>;
                } else {
                    const quote = record.countryName && record.adminName;
                    return (
                        <div className='default-table-height'>
                            <span>{record.countryName}{quote && ','}{record.adminName}</span>
                        </div>
                    );
                }
            },
            onCell: (record) => handlPlaceNameCellColSpan(record)
        },
        {
            title: () =>
                <TableHeaderCell
                    title='ID'
                    type='sort'
                    sortCallBack={() => sortIdSection()}
                />,
            dataIndex: 'code',
            width: '136px',
            render: (text, record) => {
                return (
                    <button onClick={() => {
                        console.log("test is goog for us");
                        onClickTargetRow(record);
                    }} style={{ color: '#0071CD' }}>{text}</button>
                );
            },
            onCell: (record) => handlCellColSpan(record)
        },
        {
            title: () =>
                <TableHeaderCell
                    title='Name'
                    type='sort'
                    sortCallBack={() => sortNameSection()}
                />,
            dataIndex: 'name',
            width: '180px',
            onCell: (record) => handlCellColSpan(record)
        },
        {
            title: 'Coordinates(Long, Lat)',
            dataIndex: 'lat',
            width: '220px',
            render: (_, record) => {
                if (record.countryNameSection) {
                    return null;
                } else {
                    return (
                        <span>
                            {`${record.lng},${record.lat}`}
                        </span>
                    );
                }
            },
            onCell: (record) => handlCellColSpan(record)
        },
        {
            title: () => (
                <TableHeaderCell
                    title='Type'
                    type='filter'
                    filterIconSide='right'
                    filterSourceArray={[...fielTypeDataSource]}
                    filterCallBack={({ item }) => handleFilterTargetType(item)}
                />
            ),
            dataIndex: 'fiTyName',
            width: '150px',
            onCell: (record) => handlCellColSpan(record)
        },
        {
            // title: () => (
            //     <TableHeaderCell
            //         title='Depth'
            //         type='filter'
            //         filterIconSide='left'
            //         filterSourceArray={[...depthDataSource]}
            //         filterCallBack={({ item }) => handleFilterTargetDepth(item)}
            //     />
            // ),
            title: 'Max Depth(cm)',
            dataIndex: 'depth',
            width: '180px',
            onCell: (record) => handlCellColSpan(record)
        },
        {
            title: 'Soil Analysis',
            dataIndex: 'analysisDate',
            render: (text: string) => {
                return (<span>{text ? handleSoilAnalysisDateFormat(text) : '_'}</span>);
            },
            width: '150px',
            onCell: (record) => handlCellColSpan(record)
        },
        {
            title: () => (
                <TableHeaderCell
                    title='Status'
                    type='filter'
                    filterIconSide='right'
                    filterSourceArray={[...statusDataSource]}
                    filterCallBack={({ item }) => handleFilterTargetStatus(item)}
                />
            ),
            dataIndex: 'status',
            width: '180px',
            render: (text) => (<span style={{ color: text === 'Draft' ? '#868CA2' : (text === 'Published' ? '#009936' : '#0071CD') }}>{text}</span>),
            onCell: (record) => handlCellColSpan(record)
        }
    ];


    // SECTION:  define function or callback Area
    const splitByRegionButtonClick = () => {
        if (!sortByRegion) {
            setSortByRegion(true);
        }
    };

    const sortByRegionFunc = (profileList: ISoilProfileModel[]) => {
        const cacheSoilProfileList = [...profileList];
        const sortProfilesList = cacheSoilProfileList.sort((preItem, afterItem) => {
            return preItem.countryName.localeCompare(afterItem.countryName);
        });
        const seperateIndexObjArr: { index: number, countryName:string }[] = [];
        const seperateIndexObj: { index: number, countryName:string } = { index: 0, countryName: '' };
        sortProfilesList.forEach((item, index) => {
            if (seperateIndexObj.countryName !== item.countryName) {
                seperateIndexObj.countryName = item.countryName;
                seperateIndexObj.index = index;
                seperateIndexObjArr.push({...seperateIndexObj});
            }
        });

        const seperateIndexObjArrReverse = seperateIndexObjArr.reverse();
        let startId = 10000;
        seperateIndexObjArrReverse.forEach((item) => {
            const countryItem: ISoilProfileModel = {
                placeName: `Country,${item.countryName}`,
                adminName: '',
                check: 0,
                code: '',
                contributor: '',
                countryCode: '',
                countryName: '',
                depth: 0,
                description: '',
                elevation: 0,
                fiTyName: '',
                id: startId,
                lat: 0,
                lng: 0,
                name: '',
                publisher: '',
                regionName: '',
                status: '',
                userID: '',
                analysisDate: '' };
            cacheSoilProfileList.splice(item.index, 0, countryItem);
            startId += 1;
        });
        return cacheSoilProfileList;
    };

    const splitByAllButtonClick = () => {
        setSortByRegion(false);
    };

    const clickAddNewProfile = () => {
        setVisible(true);
    };

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50 ) {
            setIsFetching(true);
        } else {
            // console.log('unreach');
        }
    };

    const sortIdSection = () => {
        // if click the sort button all table result enter in sort model
        setSortByRegion(false);
        const currentAscending = !ascending;
        setAscending(currentAscending);
        setSortCol('code');

        refreshProfileList({
            localSortRegion: false,
            searchString: searchString,
            cacheAscending: currentAscending,
            sortCol: 'code',
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    };

    const sortNameSection = () => {
        // if click the sort button all table result enter in sort model
        const currentAscending = !ascending;
        setAscending(currentAscending);
        setSortCol('name');
        setSortByRegion(false);
        refreshProfileList({
            localSortRegion: false,
            searchString: searchString,
            cacheAscending: currentAscending,
            sortCol: 'name',
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    };

    const handleEditProfile = () => {
        setProfileDetailVisible(false);
        setVisible(true);
    };

    // if the value was confirm search the list
    const handleInputValueChange = (value) => {
        // setInputValue(e.target.value);
        setSearchString(value);
        setSortByRegion(false);
        refreshProfileList({
            localSortRegion: sortByRegion,
            searchString: value,
            cacheAscending: ascending,
            sortCol,
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    };

    const handleOk = () => {
        setVisible(false);
        // if save success and commit it to the server reset the soil profile page model
        dispatch(resetTheSoilCreatProfiles());
    };

    const handleCancel = () => {
        setVisible(false);
    };

    // if ok or cancel we hide the modal and then request for profiles base on the param
    const handleConfirmOrCancelSelectRegion = () => {
        if (selectedStateCount === 0) {
            return confirm({
                className: 'soil-profile-warning-div',
                okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
                title: '',
                icon: (
                    <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <SoilProfileWarningAlertIcon />
                        <span style={{
                            color: '#14151C',
                            fontSize: '16px',
                            fontFamily: 'Noto-Sans-Semibold',
                            fontWeight: 600,
                            marginLeft: '17px'
                        }}>
                            Warning
                        </span>
                    </div>),
                content: 'Do you want to leave without selection?',
                okText: 'OK',
                onCancel() {
                    console.log('Cancel');
                },
                onOk: () => {
                    setShowStateSelector(false);
                    refreshProfileList({
                        localSortRegion: sortByRegion,
                        searchString: searchString,
                        cacheAscending: ascending,
                        sortCol: 'code',
                        strType: currentFilterType,
                        strStatus: currentFilterStatus,
                        selectedStateCount: 0
                    });
                }
            });
        }
        setShowStateSelector(false);
        refreshProfileList({
            localSortRegion: sortByRegion,
            searchString: searchString,
            cacheAscending: ascending,
            sortCol,
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
    };

    const selectedAllRegion = async () => {
        setSelectedRegion({
            northUSA: true,
            europe: true,
            asia: true,
            antarctica: true,
            sourthUSA: true,
            africa: true,
            oceania: true
        });
        setShowStateSelector(false);
        refreshProfileList({
            localSortRegion: false,
            searchString: searchString,
            cacheAscending: false,
            sortCol: 'code',
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount: 7
        });
    };

    const onClickTargetRow = (record) => {
        const profileId = record.id;
        const profileCode = record.code;
        fetchProfilePreviewData(profileCode, profileId);
        setProfileDetailVisible(true);
    };

    const onSelectChange = (newSelectedRowKeys, selectedRows) => {
        if (soilProfilesList.length === newSelectedRowKeys.length) {
            dispatch(updateProfileSelectedList(soilProfilesList));
        }
        if (newSelectedRowKeys.length === 0) {
            dispatch(updateProfileSelectedList([]));
        }
        let countryIndexArr = [];
        selectedRows.forEach((keyValue, index) => {
            if (keyValue.id > 1000) {
                countryIndexArr.push(index);
            }
        });
        countryIndexArr = countryIndexArr.reverse();
        countryIndexArr.forEach(index => {
            selectedRows.splice(index, 1);
        });

        if (!visible && !showStateSelector && !profileDetailVisible === true) {
            dispatch(updatePanelVisible(true));
        }
    };

    const onSelect = (select: ISoilProfileModel, selected: boolean, selectedRows) => {
        console.log('select:====', select);
        console.log('selected:====', selected);
        let newSelectedProfileList: ISoilProfileModel[] = [...profileSelectedList];
        if (selected) {
            newSelectedProfileList.push(select);
        } else {
            newSelectedProfileList = newSelectedProfileList.filter((item) => item.id !== select.id);
        }
        dispatch(updateProfileSelectedList(newSelectedProfileList));
        if (!visible && !showStateSelector && !profileDetailVisible === true) {
            dispatch(updatePanelVisible(true));
        }
    };

    const rowSelection = {
        profileSelectedList,
        onChange: onSelectChange,
        onSelect: onSelect
    };

    const deleteTargetProfile = async (profileId) => {
        try {
            dispatch(updateShowLoading(true));
            await soilProfileDeleteTargetProfile(profileId);
            setProfileDetailVisible(false);
            // if remove target item success
            refreshProfileList({
                localSortRegion: sortByRegion,
                searchString: searchString,
                cacheAscending: ascending,
                sortCol: sortCol,
                strType: currentFilterType,
                strStatus: currentFilterStatus,
                selectedStateCount
            });
            fetchMySoilProfilesCount();
            fetchAllSoilProfilesCount();
            dispatch(updateShowLoading(false));
        } catch (err) {
            console.log('err', err);
            dispatch(updateShowLoading(false));
        }
    };

    // if delete success would be request it again
    const deleteProfileSuccess = async (profileId) => {
        confirm({
            className: 'soil-profile-warning-div',
            okButtonProps: { style: { borderRadius: '16px', width: '80px' }},
            title: '',
            icon: (
                <div style={{height: '50px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                    <SoilProfileWarningAlertIcon />
                    <span style={{
                        color: '#14151C',
                        fontSize: '16px',
                        fontFamily: 'Noto-Sans-Semibold',
                        fontWeight: 600,
                        marginLeft: '17px'
                    }}>
                            Warning
                    </span>
                </div>),
            content: 'You are about to remove selected profile from CE Hub.',
            okText: 'OK',
            onCancel: () => {
                console.log('Cancel');
            },
            onOk: () => {
                deleteTargetProfile(profileId);
                fetchMySoilProfilesCount();
            }
        });
    };

    const addProfileSuccess = () => {
        // if success need to reset the sort col mode
        setSortCol('code');
        setAscending(false);
        refreshProfileList({
            localSortRegion: sortByRegion,
            searchString: searchString,
            cacheAscending: ascending,
            sortCol,
            strType: currentFilterType,
            strStatus: currentFilterStatus,
            selectedStateCount
        });
        fetchMySoilProfilesCount();
        fetchAllSoilProfilesCount();
        setVisible(false);
    };

    // SECTION: render UI area
    return (
        <div className="soil-profile-content">
            <Modal
                open={showStateSelector}
                className={'first-in-modal'}
                onCancel={handleConfirmOrCancelSelectRegion}
                onOk={handleConfirmOrCancelSelectRegion}
                footer={null}
                closeIcon={<SoilCloseIcon />}
            >
                <Spin spinning={stateSelectSpining}>
                    <div className='select-region-header-div'>
                        <h3>
                            Select Regions
                        </h3>
                    </div>
                    <div className='select-region-intro-div'>
                        Select the region you are interested in. This will speed up the search
                        for Soil Profiles (soil properties by location). You can change the region
                        in the settings at any time.
                    </div>
                    <div className='select-state-div'>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                northUSA: !selectedRegion.northUSA
                            });
                        }}>
                            <SoilProfileNorthAmeraica {...{selected: selectedRegion.northUSA }} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                europe: !selectedRegion.europe
                            });
                        }}>
                            <SoilProfileEurope {...{selected: selectedRegion.europe }} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                asia: !selectedRegion.asia
                            });
                        }}>
                            <SoilProfileAsia selected={selectedRegion.asia} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                antarctica: !selectedRegion.antarctica
                            });
                        }}>
                            <SoilProfileAntartica {...{selected: selectedRegion.antarctica }} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                sourthUSA: !selectedRegion.sourthUSA
                            });
                        }}>
                            <SoilProfileSourthAmeraica {...{selected: selectedRegion.sourthUSA }} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                africa: !selectedRegion.africa
                            });
                        }}>
                            <SoilProfileAfrica {...{selected: selectedRegion.africa }} />
                        </Button>
                        <Button className={'state-button'} onClick={() => {
                            setSelectedRegion({
                                ...selectedRegion,
                                oceania: !selectedRegion.oceania
                            });
                        }}>
                            <SoilProfileOceania {...{selected: selectedRegion.oceania }} />
                        </Button>
                    </div>
                    <div className='select-region-footer-div'>
                        <Button
                            key='select-all'
                            className='select-all-button'
                            onClick={selectedAllRegion}
                        >
                            Select all and continue
                        </Button>
                        <Button key='done' className='done-button' onClick={() => handleConfirmOrCancelSelectRegion()}>
                            Done
                        </Button>
                    </div>
                </Spin>
            </Modal>
            <SoilProfileCreateView
                visible={visible}
                handleCancel={handleCancel}
                handleOk={handleOk}
                addSuccessCallBack={() => addProfileSuccess()}
            />
            <Modal
                open={profileDetailVisible}
                width='950px'
                onCancel={() => setProfileDetailVisible(false)}
                title={'Soil Profile Preview'}
                centered
                footer={null}
                style={{
                    width: '950px',
                    borderRadius: '16px',
                    overflow: 'hidden',
                }}
                closeIcon={<SoilCloseIcon />}
            >
                <SoilProfilePreview
                    layerDetail={layerDetail}
                    profileDetail={profileDetail}
                    profileDatailSpin={profileDatailSpin}
                    deleteCallback={(profileId) => deleteProfileSuccess(profileId)}
                    editCallback={() => handleEditProfile()}
                />
            </Modal>
            <DetailModel
                visible={selectedSoilAnalysisVisible}
                editItem={selectedSoilAnalysis}
                edit={(editParam => {
                    setEditParam(editParam);
                    dispatch(updateSelectedSoilAnalysisVisible(false));
                    setAddAnalysisVisible(true);
                })}
                onCancel={() => {
                    dispatch(updateSelectedSoilAnalysisVisible(false));
                }}
                childChangeIsShowPreviewModal={()=>{
                    dispatch(updateSelectedSoilAnalysisVisible(false));
                }}
            />
            <AddModel
                visible={addAnalysisVisible}
                editParam={editParam}
                addSuccessCallBack={() => {
                    setAddAnalysisVisible(false);
                }}
                visibleCallback={() => setAddAnalysisVisible(false)}
            />
            <Modal
                open={allProfileCountModalVisible}
                title={`${allProfilesCount} soil profiles`}
                style={{
                    position: 'absolute',
                    top: '100px',
                    left: '100px',
                    borderRadius: '4px !important',
                    height: '200px',
                }}
                width='340px'
                footer={null}
                onCancel={() => {
                    setAllProfileCountModalVisible(false);
                }}
                onOk={() => setAllProfileCountModalVisible(false)}
                closeIcon={<SoilCloseIcon />}
            >
                <div className='profile-count-container'>
                    <div className='profile-count-image'>
                        <img src={ProfileCountImg} className='profile-count-image-style' />
                    </div>
                    <div>
                          A soil profile is a set of soil layers by location
                          used for soil analysis. Find a ready-made soil profile by location or create a new one.
                    </div>
                </div>
            </Modal>
            <div className="top-bar">
                <IF show={selectMySoilProfile}>
                    <div className='soil-profiles-top-exchange'>
                        <span className='soil-profile-home-icon'>
                            <SoilProfileHomeIcon />
                        </span>
                        <span
                            onClick={() => setSelectMySoilProfile(false)}
                            className='all-soil-profiles'
                        >
                            <a>All Soil Profiles</a>
                        </span>
                        <span className='separate-span'>/</span>
                        <span className='my-soil-profiles'><a>My Soil Profiles</a></span>
                    </div>
                </IF>
                <div className={`nav-bar ${!selectMySoilProfile && 'margin-top'}`}>
                    <button id="back-button">
                        <h3 className="soil-profile-header">Soil Profile</h3>
                    </button>
                    <button className="exclamation-button" onClick={() => setAllProfileCountModalVisible(true)}>
                        <ExclamationMarkSvgComponent />
                    </button>
                </div>
                <div className="search-div">
                    <HeaderSearch
                        placeholder='Search'
                        className="soil-profile-search"
                        GetAnalyses={(value) => handleInputValueChange(value) }
                    />
                    <Dropdown className="drop-down-list" overlay={<Menu items={menusArr} />} trigger={['click']}>
                        <a
                            className="ant-dropdown-link"
                            onClick={e => e.preventDefault()}
                        >
                            <Button type="link">{sortByRegion ? 'Split By Country' : 'All'}<DownOutlined style={{fontSize:10}}/>
                            </Button>
                        </a>
                    </Dropdown>
                    <IF show={userInfo?.roleName !== 'Reader'}>
                        <Button
                            className="add-soil-profile"
                            type="default"
                            shape="round"
                            icon={ <PlusOutlined /> }
                            onClick={() => clickAddNewProfile()}
                        >
                        Add Soil Profile
                        </Button>
                    </IF>
                    <IF show={!selectMySoilProfile}>
                        <Button
                            type='primary'
                            className='my-profiles-folder'
                            onClick={() => {
                                setSortByRegion(false);
                                setSelectMySoilProfile(true);
                            }}
                        >
                            <SoilProfileFolderIcon className='my-proifile-icon' />
                            <span className='my-profile-text' >
                                My Soil Profiles
                            </span>
                            <span className='my-profile-count-span'>
                                {profilesCount}
                            </span>
                        </Button>
                    </IF>
                </div>
            </div>
            <div className="soil-profile">
                <Table
                    className="profile-table"
                    rowSelection={rowSelection}
                    rowKey={record => record.id}
                    columns={columns}
                    dataSource={soilProfilesList}
                    pagination={false}
                    rowClassName={(record) => {
                        const result = record?.placeName?.split(',');
                        const isCountryNameSection = result && result[0] === 'Country';
                        if (isCountryNameSection) {
                            return 'section-div-background';
                        }
                        return '';
                    }}
                />
            </div>
        </div>
    );
}

